export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9553.7da70c35.jpg";